// images
import interactivePhoto from '@/assets/images/pollsActionCard.jpg';
import templatePhoto from '@/assets/images/Temp-LibraryAction.png';
import pdkAction from '@/assets/images/pdkAction.jpg';
import sportradarNfl from '@/assets/images/SportradarNFLAction.jpg';
import StreamDeckProductCard from '@/assets/images/StreamDeckProductCard.jpg';
import ShowBuilderAction from '@/assets/images/ShowBuilderAction.jpg';

const quickActions = [
  {
    name: 'Control Tagboard Producer from any device',
    description:
      'Trigger graphics seamlessly from a physical device using our new Producer API and Elgato Stream Deck plugin.',
    image: {
      src: StreamDeckProductCard,
      alt: 'Tagboard Producer Stream Deck plugin preview.',
    },
    flag: 'new',
    button: {
      severity: 'primary',
      outlined: false,
      content: 'Get the Plugin',
      sportradar: StreamDeckProductCard,
      url: 'https://marketplace.elgato.com/product/tagboard-producer-d7fcb89d-cdbf-4b43-97d1-ff934d30dffa',
      classes: 'bg-secondary-color text-white',
    },
    dataEntity: 'quick-action-stream-deck-plugin',
    dataTest: 'quick-action-stream-deck-plugin',
  },
  {
    name: 'A New Way to Build Your Shows',
    description:
      'Streamline your pre-production process by organizing graphics into reusable rundowns and segments.',
    image: {
      src: ShowBuilderAction,
      alt: 'Show Builder rundown and segment preview.',
    },
    flag: 'new',
    button: {
      severity: 'primary',
      outlined: false,
      content: 'Build Your First Show',
      route: '/shows',
      classes: '',
    },
    dataEntity: 'quick-action-show-builder',
    dataTest: 'quick-action-show-builder',
  },
  {
    name: 'Build with Partner Apps',
    description:
      'Browse partner apps, including prediction games, light shows, and prize drops, ready to add into any graphic.',
    image: {
      src: pdkAction,
      alt: 'Partner apps marketplace preview.',
    },
    category: 'create',
    button: {
      severity: 'primary',
      outlined: false,
      content: 'Explore the Marketplace',
      url: 'https://tagboard.com/app-marketplace/',
      classes: 'bg-secondary-color text-white',
    },
    dataEntity: 'quick-action-partner-apps',
    dataTest: 'quick-action-partner-apps',
  },
  {
    name: 'Get Ready for Football Season',
    description:
      'Build broadcast-ready NFL & CFB graphics powered by live sports stats, no code required',
    image: {
      src: sportradarNfl,
      alt: 'NFL and college football graphics preview.',
    },
    button: {
      severity: 'primary',
      outlined: false,
      content: 'Design with Data',
      sportradar: sportradarNfl,
      url: 'https://app.tagboard.com/templates?dataTypes=ncaa+fb&dataTypes=nfl',
      url2: 'https://support.tagboard.com/knowledge-base/advanced-elements-sportradar',
      classes: '',
    },
    dataEntity: 'quick-action-sportradar-nfl',
    dataTest: 'quick-action-sportradar-nfl',
  },
  {
    name: 'Engage your Audience. Own the Data.',
    description:
      'Run polls and trivia with creative control, real-time insights, and '
      + 'now with first-party data capture built in.',
    image: {
      type: 'jpg',
      src: interactivePhoto,
      alt: 'Polls and trivia builder preview.',
    },
    category: 'produce',
    button: {
      severity: 'primary',
      outlined: false,
      content: 'Create a Poll',
      createType: 'poll',
      classes: 'bg-secondary-color',
    },
    dataEntity: 'quick-action-polls',
    dataTest: 'quick-action-polls',
  },
  {
    name: 'Skip the Blank Canvas',
    description:
      'Start from a pro-designed template or add an entire graphics package, one click.',
    image: {
      src: templatePhoto,
      alt: 'Template Library preview.',
    },
    category: 'create',
    button: {
      severity: 'primary',
      outlined: false,
      content: 'Browse Templates',
      url: 'https://app.tagboard.com/templates',
      classes: 'bg-blue-500 text-white',
    },
    dataEntity: 'quick-action-template-library',
    dataTest: 'quick-action-template-library',
  },
];

export default quickActions;
